
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Testable from '@/mixins/Testable'
import { Panorama } from '@/models/Panorama'

@Component({
	components: { V3Page: () => import('@/components/V3Page.vue') }
})
export default class SphereViewerDialog extends Mixins(Testable) {
	@Prop({ required: true })
	panorama!: Panorama

	@Prop({ required: false, default: 0 })
	startBearing!: number

	@Prop({ required: false, default: false })
	opened!: boolean
}
